// FSA Statements — shared line helpers (Statement screen + bulk re-round).

import type { EvaluatedLine, StatementLineData, StatementWorkspaceData } from 'api/types/fsa/statementData.types';

/** A saved Statement line rebuilt from the live evaluation (what "Refresh from Notes" writes). */
export function evaluatedToLine(ev?: EvaluatedLine): StatementLineData {
  return {
    amount_actual:       ev?.amountActual ?? 0,
    amount_rounded:      ev?.amountRounded ?? 0,
    prior_amount_actual: ev?.priorAmountActual ?? 0,
    prior_amount_rounded:ev?.priorAmountRounded ?? 0,
    source:              ev?.source ?? 'note',
    is_override:         false,
  };
}

/**
 * "Refresh all from Notes": every line takes the live evaluation EXCEPT an
 * auditor override (explicit intent — kept). Returns the refreshed
 * workspace and the codes of the overrides it kept.
 */
export function refreshStatementFromLive(
  saved: StatementWorkspaceData,
  live: Record<string, EvaluatedLine>,
): { workspace: StatementWorkspaceData; keptOverrides: string[] } {
  const lines = { ...saved.lines };
  const keptOverrides = Object.entries(saved.lines)
    .filter(([, l]) => l?.is_override)
    .map(([code]) => code);
  for (const [code, ev] of Object.entries(live)) {
    const prev = saved.lines[code];
    if (prev?.is_override) continue;
    // A line with a workings sheet (Cash Flow) is recomposed by the server
    // on save (auto + Σ adjustments) — keep it, workings included.
    if ((prev as { workings?: unknown } | undefined)?.workings) continue;
    lines[code] = evaluatedToLine(ev);
  }
  return { workspace: { ...saved, lines }, keptOverrides };
}
